import type { IStatusCards } from "./../../../../types/charts/chart/status_cards";
import { CircleExclamation, Plane, RocketLaunch } from "./../../../../assets/Icons";
import styles from "./status-cards.module.scss";

export const StatusCards = ({ list, emptyStateText = "" }: IStatusCards) => {
  return (
    <div className={styles["status-cards"]}>
      {
        list?.map((item, i: number) =>
          <div
            className={styles["status-cards__card"]}
            data-status-card-status={item.status}
            key={`status-card-${i}`}
          >
            <div className={styles["status-cards__card__icon-wrapper"]}>
              {item.status === 'down' && CircleExclamation}
              {item.status === 'up' && RocketLaunch}
              {item.status === 'equal' && Plane}
            </div>
            <div className={styles["status-cards__card__text"]}>
              {item.text}
            </div>
          </div>
        )
      }
      {list?.length === 0 && <div className={styles["status-cards__empty-state"]}>{emptyStateText}</div>}
    </div>
  )
};